import { api } from '@data/store';
import {
  ClientProductOption,
  ClientProductSprintTime,
  ClientProductSummary,
  ListResponse,
  OrganizationClient,
} from '@data/utils/types';

export const fetchClients = (organizationId: string): Promise<ListResponse<OrganizationClient>> =>
  api.get(`/organizations/${organizationId}/clients`);

// Every product in the organization, each flagged with whether this client is currently linked.
export const fetchClientProductOptions = (
  organizationId: string,
  membershipId: string,
): Promise<ListResponse<ClientProductOption>> =>
  api.get(`/organizations/${organizationId}/clients/${membershipId}/products`);

// Replaces the client's whole set of linked products, so it must be sent complete.
export const updateClientProducts = (
  organizationId: string,
  membershipId: string,
  productIds: string[],
): Promise<void> => api.put(`/organizations/${organizationId}/clients/${membershipId}/products`, { productIds });

export const fetchClientOwnProducts = (organizationId: string): Promise<ListResponse<ClientProductSummary>> =>
  api.get(`/organizations/${organizationId}/client/products`);

// Reported time on the product, one entry per sprint overlapping the window.
export const fetchClientProductTime = (
  organizationId: string,
  productId: string,
  params?: { from?: string; to?: string; asClient?: boolean },
): Promise<ListResponse<ClientProductSprintTime>> =>
  api.get(`/organizations/${organizationId}/client/products/${productId}/time`, { params });
